import { useSelector } from "react-redux";

export const usePermission = (permission) => {
  const { admin } = useSelector((state) => state.auth);
  return Boolean(admin?.permissions && admin.permissions[permission]);
};
export const Permissions = Object.freeze({
    CAN_MANAGE_ADMINS: "can_manage_admins",
    CAN_MANAGE_ANALYTIC: "can_manage_analytics",
    CAN_MANAGE_USERS: "can_manage_users",
    CAN_MANAGE_MODULES: "can_manage_modules",
    CAN_MANAGE_REPORTS: "can_manage_reports",
    CAN_MANAGE_CATEGORIES: "can_manage_categories",
    CAN_MANAGE_BANNERS: "can_manage_banners",
    CAN_MANAGE_MARKETING: "can_manage_marketing",
    CAN_MANAGE_PAYMENTS: "can_manage_payments",
    CAN_MANAGE_TICKETS: "can_manage_tickets",
    CAN_MANAGE_SETTINGS: "can_manage_settings",
    CAN_MANAGE_DELIVERY: "can_manage_delivery",
    CAN_MANAGE_SUBSCRIPTIONS: "can_manage_subscriptions",
    CAN_MANAGE_ORDERS: "can_manage_orders",
    CAN_MANAGE_COUNTRIES: "can_manage_countries",
    CAN_MANAGE_PACKAGES: "can_manage_packages",
    CAN_MANAGE_FEEDBACKS: "can_manage_feedbacks",
    CAN_MANAGE_WITHDRAWALS: "can_manage_payments",
    CAN_MANAGE_LANGUAGES: "can_manage_settings",
  });